import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { KsefGetDocumentXmlQuery, KsefGetDocumentXmlQueryHandlerBase, KsefGetDocumentXmlToPreviewQuery, KsefGetDocumentXmlToPreviewQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(KsefGetDocumentXmlQuery)
@Wrapper(KsefGetDocumentXmlQueryHandlerBase)
export class KsefGetDocumentXmlQueryHandler {
    public constructor(
        http: Http
    ) { }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(KsefGetDocumentXmlToPreviewQuery)
@Wrapper(KsefGetDocumentXmlToPreviewQueryHandlerBase)
export class KsefGetDocumentXmlToPreviewQueryHandler {
    public constructor(
        http: Http
    ) { }
}
